import type { FaireProductEntity } from "../../entity_types/product";

export const p_cubazjx2hs: FaireProductEntity = {
  token: "p_cubazjx2hs",
  type: "product",
  name: "Self-Care Habit Tracker",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl:
    "https://cdn.faire.com/fastly/deb80be57c2075fea6f524b00f348b19c42aef91543c48a086df22d969f92933.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0468962fbce955c459147f823b64a8a428fd0243d2740b59d5f022bcbca1f532.jpeg",
    "https://cdn.faire.com/fastly/9283e5173ce5a2d45d663f1af61e3f5851a880fddee79d40e5fa8b9ff6cd6ad3.jpeg",
    "https://cdn.faire.com/fastly/f4b5678dcf698eb03e0415ad64362939f1fe123a31f56a2b6ee58d43922c0467.jpeg",
    "https://cdn.faire.com/fastly/e9d7207f19124b21dcffbd29aea9ab14fd19430a2032a6f0015b25b05cdbedd6.jpeg",
  ],
  priceDollars: 9.98,
  description:
    "We all know self-care is vital to our wellness and mental health, but it’s hard to actually prioritize it on a daily basis. This habit tracker provides a no-pressure space where you can start building a self-nurturing practice—baby step by baby step. Weekly grids guide you for a whole year, along with encouraging quotes & optional reflection prompts every 4 weeks (and lots of good vibes all year long). Now let’s get this self-care party started!\n•\t52 easy-to-use weekly grids\n•\tDaily support for mindfulness & self-love—plus \n•\tDoubles as a low-maintenance daily journal and gratitude journal\n•\tPaperback, 128 pages, 6 x 8 inches\n•\tFoil stamping, lay-flat binding, elastic closure",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:31.728Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
